import React, { memo } from 'react'
import * as Styled from './styled'

const UnlimitedInfinityIcon: React.FC = () => (
  <Styled.InfinityIconWrapper>
    <Styled.InfinityIconBase />
    <Styled.InfinityIconShine />
  </Styled.InfinityIconWrapper>
)

export default memo(UnlimitedInfinityIcon)
